import React, { useEffect, memo}  from 'react';
import { useTheme } from '@emotion/react';
import { Link, Typography, useMediaQuery } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useRecoilState_TRANSITION_SUPPORT_UNSTABLE, useRecoilValue_TRANSITION_SUPPORT_UNSTABLE, useSetRecoilState } from 'recoil';
import useSearchHours from 'src/SearchHours/hooks/useSearchHours';
import { filterSearchSelectedState, hoursAvailableState, loadingDaysCalendarState, loadingHoursState, professionalsMatchCovenantState, professionalsNoMatchCovenantState } from 'src/SearchHours/state/atoms';
import EmptyCalendar from 'src/shared/components/notFoundData/EmptyCalendar';
import { showModalEditFiltersState } from 'src/store/reservation/reservationState';
import CardImagenologia from './CardImagenologia';

const ListImagenologia = memo(() => {
    const theme = useTheme();
    const hoursAvailable = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(hoursAvailableState);
    const loadingHours = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(loadingHoursState);
    const loadingDaysCalendar = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(loadingDaysCalendarState)
    const { isEmptyFiltersImagenologia } = useSearchHours();
    const filterSearchSelected = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(filterSearchSelectedState);
    const [professionalsMatchCovenant, setProfessionalsMatchCovenant] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(professionalsMatchCovenantState);
    const [professionalsNoMatchCovenant, setProfessionalsNoMatchCovenant] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(professionalsNoMatchCovenantState);
    const isMediaScreen = useMediaQuery(theme.breakpoints.down('md'));
    const setShowModalEditFilters = useSetRecoilState(showModalEditFiltersState);
    //const [loadingHours, setLoadingHours] = useState(false);

    const stylesTitles = {
        position: 'sticky',
        top: isMediaScreen ? '168px' : '68px',
        padding: '12px 0px 12px 0px',
        background: '#F4F6F8',
        zIndex: 12,
    };


    useEffect(() => {
        // pregunto si la prevision tiene valor, para buscar aquellos que coinciden y los que no
        if (filterSearchSelected.covenantSelected.value !== '' && hoursAvailable && hoursAvailable.length > 0) {
            // del resultado original, filtro aquellos que coinciden
            setProfessionalsMatchCovenant(hoursAvailable.filter(x => x.coincideConPrevision === true))

            // del resultado original, filtro aquellos que no coinciden
            setProfessionalsNoMatchCovenant(hoursAvailable.filter(x => x.coincideConPrevision === false))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hoursAvailable])

    if (isEmptyFiltersImagenologia()) {
        return (
            <EmptyCalendar
                mt={10}
                children={
                    <>
                        Para revisar nuestras ofertas médicas, por favor inicie su búsqueda
                        <Link
                            style={{
                                textDecoration: "none",
                                fontSize: "18px",
                                fontWeight: 700,
                                lineHeight: "18px",
                                fontStyle: 'italic'
                            }}
                            component="button"
                            variant="body2"
                            color="secondary"
                            onClick={() => setShowModalEditFilters(true)}
                        >
                            &nbsp;aquí
                        </Link>
                    </>
                }
            />
        )
    }

    if (!loadingHours && !loadingDaysCalendar && hoursAvailable.length === 0) return <EmptyCalendar text={"No existe disponibilidad para los filtros seleccionados"} />
    
    return (
        <div>
            {/* {
                professionalsMatchCovenant.length > 0 && filterSearchSelected.covenantSelected.value !== '' && (
                    <>
                        <Typography
                            variant='h5'
                            color={grey[700]}
                            fontWeight={700}
                            mb={2}
                            style={stylesTitles}
                        >
                            {professionalsMatchCovenant.length} coincidencia{professionalsMatchCovenant.length > 1 ? 's' : ''} con {filterSearchSelected.covenantSelected.value}
                        </Typography>
                        {
                            professionalsMatchCovenant.map((el, index) => (
                                <CardImagenologia key={`professional_${index}`} professional={el} />
                            ))
                        }
                    </>
                )
            }
            {
                professionalsNoMatchCovenant.length > 0 && filterSearchSelected.covenantSelected.value !== '' && (
                    <>
                        <Typography
                            variant='h5'
                            color={grey[700]}
                            fontWeight={700}
                            mb={2}
                            style={stylesTitles}
                        >
                            {
                                professionalsNoMatchCovenant.every(x => x.convenios.length === 0) ?
                                    `Otros especialistas encontrados (${professionalsNoMatchCovenant.length})` :
                                    `${professionalsNoMatchCovenant.length} resultado${professionalsNoMatchCovenant.length > 1 ? 's' : ''} para otras previsiones`
                            }

                        </Typography>
                        {
                            professionalsNoMatchCovenant.map((el, index) => (
                                <CardImagenologia key={`professional_${index}`} professional={el} />
                            ))
                        }
                    </>
                )
            } */}
            {
                 hoursAvailable.map((el, index) => (
                    <CardImagenologia key={`professional_${index}`} professional={el} />
                ))
            }
        </div>
    )
})

export default ListImagenologia;